// Function to crop the image using canvas and return a Blob
async function getCroppedImg(imageSrc, pixelCrop) {
  const image = new Image();
  image.src = imageSrc;
  await new Promise((resolve) => {
    image.onload = resolve;
  });

  const canvas = document.createElement("canvas");
  canvas.width = pixelCrop.width;
  canvas.height = pixelCrop.height;
  const ctx = canvas.getContext("2d");

  ctx.drawImage(
    image,
    pixelCrop.x,
    pixelCrop.y,
    pixelCrop.width,
    pixelCrop.height,
    0,
    0,
    pixelCrop.width,
    pixelCrop.height
  );

  return new Promise((resolve, reject) => {
    canvas.toBlob((blob) => {
      if (!blob) {
        // Reject the Promise with an error message
        reject(new Error("Canvas is empty"));
        return;
      }
      blob.name = "newFile.jpeg"; // Create a file name for the blob
      resolve(blob); // Resolve the Promise with the blob
    }, "image/jpeg");
  });
}

export default getCroppedImg;
